export const scrollToDiv = (divId: string): void => {
  const element = document.getElementById(divId);
  element?.scrollIntoView({ behavior: "smooth" });
};
